import CryptoJS from 'crypto-js'
import { v4 as uuidv4 } from 'uuid'

const seretKey = CryptoJS.enc.Utf8.parse('yikejiaoyu_2025_') // 16字节
const kv = CryptoJS.enc.Utf8.parse('yikesoft_2025_su')
const duration_seconds = 60 * 2 //两分钟失效

export const mySecKey = () => {
    const srcs = CryptoJS.enc.Utf8.parse(
        JSON.stringify({
            expire_t: Math.floor(Date.now() / 1000) + duration_seconds
        })
    )
    const mySecKeySTR = CryptoJS.AES.encrypt(srcs, seretKey, {
        iv: kv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return mySecKeySTR.toString()
}

export const decryptData = ciphertext => {
    const decrypted = CryptoJS.AES.decrypt(ciphertext, seretKey, {
        iv: kv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}

export const getImageWH = file => {
    return new Promise((resolve, reject) => {
        const img = new Image()
        const url = URL.createObjectURL(file)
        img.onload = () => {
            resolve({ width: img.naturalWidth, height: img.naturalHeight })
            URL.revokeObjectURL(url)
        }
        img.onerror = () => {
            reject(new Error('图片加载失败！请重新上传'))
            URL.revokeObjectURL(url)
        }
        img.src = url
    })
}

export const randUUID = (len = 8) => {
    return uuidv4().replace(/-/g, '').substring(0, len)
}

export const fileExt = file => {
    const fileInfo = file.name.split('.')
    return fileInfo[fileInfo.length - 1].toLowerCase()
}
